import styled from 'styled-components';

import { BREAKPOINTS } from '../../../app/appConstants';

export const MainHeaderStyled = styled.div`
    content: ' ';
    display: block;
    padding: 20px 48px;
    width: 100%;
    z-index: 10;
    background: ${({background}) => background ? background : 'var(--color-base)'};
    ${({fixed}) => !!fixed && 'position: fixed'};
    ${({fixed}) => !!fixed && 'top: 0'};
    @media (max-width: ${BREAKPOINTS.large}px) {
        padding: 20px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 16px;
    }
`;

export const MainHeaderFixedPlaceholderStyled = styled.div`
    box-sizing: content-box;
    height: 48px;
    padding: 20px 48px;
    @media (max-width: ${BREAKPOINTS.large}px) {
        padding: 20px;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        height: 32px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 16px;
    }
`;

export const MainHeaderFloatStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: right;
    z-index: 1000;
    height: 48px;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        height: 32px;
    }
`;

export const MainHeaderItemStyled = styled.div`
    &:last-child {
        flex: 1 0 auto;
    }
`;

export const MainHeaderItemControlPanelStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
 
    > a {
        line-height: 32px;
        font-size: 14px;
        padding-left: 32px;
        padding-right: 32px;

        @media (max-width: ${BREAKPOINTS.medium}px) {
            line-height: 16px;
            font-size: 12px;
            padding-left: 16px;
            padding-right: 16px;
        }
    }
`;
